import { ReactComponent as AVAX } from "./assets/chains/AVAX.svg";
import { ReactComponent as BNB } from "./assets/chains/BNB.svg";
import { ReactComponent as MATIC } from "./assets/chains/MATIC.svg";

export const chains = {
    "chains.avax": AVAX,
    "chains.bnb": BNB,
    "chains.matic": MATIC,
};
